<template>
  <main class="mdl-layout__content">
    <div class="page-content">

      <h1 class="mdl-typography--headline" v-text="translate('Rapport')"></h1>
      <div
          v-if="( $root.isGuest() || $route.params.code ) && !isApiReport() && !isRentalReport() && !isEuropcarReport()"
          class="report-summary mdl-shadow--2dp mdl-grid">
        <div v-if="!parseInt(report.confirmation) || parseInt(report.confirmation)<0" class="at-btn-panel">
          <button :disabled="$root.ui.isLoading('confirmReport')" @click.prevent="confirmReport(1)"
                  id="js-accept-report" class="mdl-button mdl-js-button at-btn-accept"
                  v-text="translate('Godta takst')"></button>
          <a :href="'mailto:'+( parseInt(report.id_client) ? report.client_email : report.surveyor_email)"
             :disabled="$root.ui.isLoading('confirmReport')" @click="confirmReport(-1)" id="js-decline-report"
             class="mdl-button mdl-js-button at-btn-decline" v-text="translate('Avslå takst')"></a>
        </div>
        <div v-else v-text="parseInt(report.confirmation)>0 ? 'Confirmed' : 'Declined'"></div>
      </div>

      <h2 v-if="!($route.params.code && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))"
          class="mdl-typography--title" v-text="translate('Kontaktinfo')"></h2>
      <div class="report-summary mdl-shadow--2dp mdl-grid">
        <div class="mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone">
          <ul class="mdl-list">
            <li class="mdl-list__item">
              <span class="mdl-list__item-primary-content"><i class="material-icons mdl-list__item-icon">person</i><span
                  v-text="report.contact_name"></span></span>
            </li>
            <li v-if="!($route.params.code && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))"
                class="mdl-list__item">
			    <span class="mdl-list__item-primary-content">
				    <i class="material-icons mdl-list__item-icon">email</i>
                    <a :href="'mailto:' + report.contact_email" v-text="report.contact_email"></a>
			    </span>
            </li>

            <li class="mdl-list__item">
              <span class="mdl-list__item-primary-content"><i class="material-icons mdl-list__item-icon">home</i><span
                  v-text="report.address"></span></span>
            </li>

            <li v-if="isApiReport()" class="mdl-list__item">
			    <span class="mdl-list__item-primary-content">
				    <i class="material-icons mdl-list__item-icon">error</i>
                    <span v-text="formatDate(report.damaged_at, true, report.report_language)"></span>
			    </span>
            </li>
            <li v-if="report.service_time && 'undefined' != report.service_time" class="mdl-list__item">
			    <span class="mdl-list__item-primary-content">
					  <i class="material-icons mdl-list__item-icon">timelapse</i>
            <span v-text="report.service_time"></span>
            <span style="margin-left:5px;" v-text="translate('repairdays')"></span>
				  </span>
            </li>
            <li v-if="report.referral_number" class="mdl-list__item">
                <span class="mdl-list__item-primary-content">
                    <i class="material-icons mdl-list__item-icon">class</i>
                    <span v-text="report.referral_number"></span>
                </span>
            </li>
          </ul>
        </div>
        <div class="mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone">
          <ul class="mdl-list">
            <li v-if="!($route.params.code  && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))"
                class="mdl-list__item">
									<span class="mdl-list__item-primary-content">
										<i class="material-icons mdl-list__item-icon">phone_android</i>
                                        <span v-text="report.contact_phone"></span>
									</span>
            </li>
            <li class="mdl-list__item">
									<span class="mdl-list__item-primary-content">
										<i class="material-icons mdl-list__item-icon">store</i>
                                        <span v-text="report.firma"></span>

									</span>
            </li>
            <li v-if="!($route.params.code && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))"
                class="mdl-list__item">
									<span class="mdl-list__item-primary-content">
										<i class="material-icons mdl-list__item-icon">language</i>
                      <span v-if="report.report_language == 'no'">Norsk rapport</span>
                      <span v-else-if="report.report_language == 'en'">Engelsk rapport</span>
                    <span v-else-if="report.report_language == 'da'">Dansk rapport</span>
                      <span v-else-if="report.report_language == 'sv'">Svensk rapport</span>

									</span>
            </li>
          </ul>
        </div>


      </div>

      <h2 class="mdl-typography--title" v-text="translate('Rapport oppsummering')"></h2>
      <div class="report-summary mdl-shadow--2dp mdl-grid">
        <div class="mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone">
          <ul class="mdl-list">
            <li class="mdl-list__item">
									<span class="mdl-list__item-primary-content">
										<i class="material-icons mdl-list__item-icon">crop_7_5</i>
                                        <span v-text="report.id_car ? report.id_car.toUpperCase() : ''"></span>
									</span>
            </li>
            <li class="mdl-list__item">
									<span v-if="(car && car.model)" class="mdl-list__item-primary-content">
										<i class="material-icons mdl-list__item-icon">directions_car</i>
                                        <span
                                            v-text="(car && car.model) ? (car.producer + ' ' + car.model) : translate('Ukjent')"></span>
									</span>
            </li>
            <li v-if="!($route.params.code  && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))"
                class="mdl-list__item">
									<span class="mdl-list__item-primary-content">
										<i class="material-icons mdl-list__item-icon">swap_horiz</i>
                                        <span v-if="report.car_mileage"
                                              v-text="parseFloat(report.car_mileage) + ' km'"></span>
									</span>
            </li>
            <li class="mdl-list__item">
									<span class="mdl-list__item-primary-content">
										<i class="material-icons mdl-list__item-icon">today</i>
                                        <span
                                            v-text="formatDate(report.created_at, true, report.report_language)"></span>
									</span>
            </li>

            <li v-if="report.damage_date"
                class="mdl-list__item">
									<span class="mdl-list__item-primary-content">
										<i class="material-icons mdl-list__item-icon">today</i>
                                        <span
                                            v-text="translate('Skadedato') + ': ' + formatDate(report.damage_date, false, report.report_language)"></span>
									</span>
            </li>

            <li v-if="report.rented_city"
                class="mdl-list__item">
                  <span class="mdl-list__item-primary-content">
                    <i class="material-icons mdl-list__item-icon">location_city</i>
                                        <span
                                            v-text="translate('Utleieby') + ': ' + report.rented_city"></span>
                  </span>
            </li>

            <li v-if="report.insurance_company"
                class="mdl-list__item">
									<span class="mdl-list__item-primary-content">
										<i class="material-icons mdl-list__item-icon">task</i>
                                        <span
                                            v-text="translate('Forsikrings selskap') + ': ' + report.insurance_company"></span>
									</span>
            </li>


            <li v-if="report.car_market && !($route.params.code && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))"
                class="mdl-list__item">
			    <span class="mdl-list__item-primary-content">
				    <i class="material-icons mdl-list__item-icon">shopping_cart</i>
                    <span
                        v-text="'Normal markedsverdi: ' + report.car_market.toLocaleString('nb-NO',{}) + ' kr'"></span>
                </span>
            </li>
          </ul>

        </div>
        <div class="mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone">
          <ul class="mdl-list">
            <li v-if="!($route.params.code && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))"
                class="mdl-list__item green">
									<span class="mdl-list__item-primary-content">
										<i class="material-icons mdl-list__item-icon">check_box</i>
										<span v-text="itemsStats[0] + ' ' + translate('Godkjent')"></span>
									</span>
            </li>
            <li v-if="!($route.params.code  && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))"
                class="mdl-list__item yellow">
									<span class="mdl-list__item-primary-content">
										<i class="material-icons mdl-list__item-icon">warning</i>
										<span v-text="itemsStats[1] + ' ' + translate('Normal slitasje')"></span>
									</span>
            </li>
            <li class="mdl-list__item red">
									<span class="mdl-list__item-primary-content">
										<i class="material-icons mdl-list__item-icon">error</i>
                                        <span v-if="isApiReport() && parseInt(report.id_user)==88"
                                              v-text="itemsStats[2] > 0 ? ('1 ' + translate('Skade')) : ('0 ' + translate('Skade'))"></span>
										<span v-else
                          v-text="itemsStats[2] > 1 ? itemsStats[2] + ' ' + translate('Skader') : itemsStats[2] + ' ' + translate('Skade')"></span>
									</span>
            </li>

            <template v-if="!isWithoutPrice()">
              <li v-if="isAldReport()" class="mdl-list__item red">
                    <span class="mdl-list__item-primary-content">
                        <i class="material-icons mdl-list__item-icon">payment</i>
                        <span
                            v-text="translate('Takstkostnad') + ': ' + report.report_fixed_cost + ' kr eks. mva'"></span>
                    </span>
              </li>
              <li v-if="!($route.params.code && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))"
                  class="mdl-list__item red">
                    <span class="mdl-list__item-primary-content">
                        <i class="material-icons mdl-list__item-icon">payment</i>
                        <span
                            v-text="translate('Totalt') + ': ' + calculateTotalCost(damageSections).toLocaleString('nb-NO',{}) + ' kr eks. mva'"></span>
                    </span>
              </li>
              <li v-else class="mdl-list__item">
                                        <span class="mdl-list__item-primary-content">
                                            <i class="material-icons mdl-list__item-icon">receipt</i>
                                            <span
                                                v-text="translate('Sum eks. mva') + ': ' + calculateTotalCost(damageSections).toLocaleString('nb-NO',{}) + ' kr'"></span>
                                        </span>
                <span class="mdl-list__item-primary-content">
                                            <span
                                                v-text="translate('Mva') + ': ' + (calculateTotalCost(damageSections)*0.25).toLocaleString('nb-NO',{}) + ' kr'"></span>
                                        </span>
              </li>
              <li v-if="($route.params.code  && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))"
                  class="mdl-list__item red">
                                        <span class="mdl-list__item-primary-content">
                                            <i class="material-icons mdl-list__item-icon">payment</i>
                                            <span
                                                v-text="translate('Totalpris inkl. mva') + ': ' + (calculateTotalCost(damageSections)*1.25).toLocaleString('nb-NO',{}) + ' kr'"></span>
                                        </span>
              </li>
            </template>
            <template
                v-if="discountIsActive() && !($route.params.code && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))">
              <li class="mdl-list__item red">
                                        <span class="mdl-list__item-primary-content">
                                            <i class="material-icons mdl-list__item-icon">card_giftcard</i>
                                            <span v-text="'Rabatt: ' + report.discount + '%'"></span>
                                        </span>
              </li>
              <li class="mdl-list__item red">
                                        <span class="mdl-list__item-primary-content">
                                            <i class="material-icons mdl-list__item-icon">payment</i>
                                            <span
                                                v-text="'Totalt: ' + ( calculateTotalCost(damageSections) - calculateTotalCost(damageSections) / 100 * report.discount ).toLocaleString('nb-NO',{}) + ' kr'"></span>
                                        </span>
              </li>
            </template>
            <li v-if="report.car_market && !($route.params.code  && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))"
                class="mdl-list__item red">
			    <span class="mdl-list__item-primary-content">
				    <i class="material-icons mdl-list__item-icon">shopping_cart</i>
                    <span
                        v-text="'Markedsverdi: ' + (report.car_market-calculateTotalCost(damageSections)).toLocaleString('nb-NO',{}) + ' kr'"></span>
				</span>
            </li>
          </ul>
        </div>
        <div v-if="!($route.params.code && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport()))"
             v-text="translate('Normal slitasje defineres som slitasje som må kunne forventes etter en gitt alder og kjørelengde, mens unormal slitasje er det motsatte.')"></div>
      </div>
      <template v-if="isServiceHistorySection()">
        <h2 class="mdl-typography--title" v-text="translate('Servicehistorikk')"></h2>
        <div class="report-summary mdl-shadow--2dp mdl-grid">
          <div v-if="isServiceHistory()" class="mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--4-col-phone">
            <ul class="mdl-list">
              <li v-for="history_item in report.service_history" class=" mdl-list__item">
                        <span class="mdl-list__item-primary-content mdl-cell--6-col">
                            <i class="material-icons mdl-list__item-icon">today</i>
                            <span v-text="history_item[0]"></span>
                        </span>
              </li>
            </ul>
          </div>
          <div v-if="isServiceHistory()" class="mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--4-col-phone">
            <ul class="mdl-list">
              <li v-for="history_item in report.service_history" class=" mdl-list__item">
                        <span class="mdl-list__item-primary-content mdl-cell--6-col">
                            <i class="material-icons mdl-list__item-icon">speed</i>
                            <span v-text="history_item[1] ? history_item[1]+' km' : ''"></span>
                        </span>
              </li>
            </ul>
          </div>
          <div v-if="report.service_history_description"
               class="mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-phone">
            <ul class="mdl-list">
              <li class=" mdl-list__item">
                        <span class="mdl-list__item-primary-content mdl-cell--12-col">
                            <i class="material-icons mdl-list__item-icon">warning</i>
                            <span v-text="report.service_history_description"></span>
                        </span>
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-if="tires_items.length">
        <h2 class="mdl-typography--title" v-text="translate('Dekk og felg')"></h2>
        <div class="report-summary mdl-shadow--2dp mdl-grid">
          <div v-if="summer_tires_items.length"
               class="mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone">
            <ul class="mdl-list">
              <li v-for="(item, idx) in summer_tires_items" class="mdl-list__item">
                        <span class="mdl-list__item-primary-content mdl-cell--12-col">
                            <i class="material-icons mdl-list__item-icon">trip_origin</i>
                            <span
                                v-text="item.caption.replace('Dekk og felg - ','') + ' - ' + item.extra_value + ' mm'"></span>
                        </span>
              </li>
            </ul>
          </div>
          <div v-if="winter_tires_items.length"
               class="mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone">
            <ul class="mdl-list">
              <li v-for="(item, idx) in winter_tires_items" class="mdl-list__item">
                        <span class="mdl-list__item-primary-content mdl-cell--12-col">
                            <i class="material-icons mdl-list__item-icon">trip_origin</i>
                            <span
                                v-text="item.caption.replace('Dekk og felg - ','') + ' - ' + item.extra_value + ' mm'"></span>
                        </span>
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template
          v-if="$root.isSurveyorCapability() || $root.isClient() || $root.isRentalCapability() || $root.isRentalCheckCapability() || $root.isEuropcarCapability() || $root.isAldCapability()">
        <h2 class="mdl-typography--title" v-text="translate('Merknad')"></h2>

        <div @change="saveReportForm()" class="report-summary mdl-shadow--2dp mdl-grid">

          <div v-if="!isEuropcarReport() && !isAldReport()"
               class="mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
               style="width:100%;">
            <input :disabled="!isEditable()" autocomplete="on" v-model="report.surveyor_initials"
                   class="mdl-textfield__input" type="text" id="report_surveyor_initials">
            <label class="mdl-textfield__label" for="report_surveyor_initials"
                   v-text="translate('Initialer/Navn takstmann')"></label>
          </div>
          <div v-if="!($route.params.code && (isApiReport() || isRentalReport())) && errors.surveyor_initials"
               class="v-error" v-text="errors.surveyor_initials"></div>
          <div
              v-if="!($route.params.code && (isApiReport() || isRentalReport())) && !isEuropcarReport() && !isAldReport()"
              class="mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
              style="width:100%;">
            <input autocomplete="on" v-model="report.discount" class="mdl-textfield__input" type="text"
                   id="report_discount">
            <label class="mdl-textfield__label" for="report_discount">{{ translate('Rabatt') }} (%)</label>
          </div>
          <div class="mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield">
            <textarea v-model.lazy="report.comment" class="mdl-textfield__input" rows="3" id="reportComment"></textarea>
            <label class="mdl-textfield__label" for="reportComment" v-text="translate('Tilleggskommentar')"></label>
          </div>
          <div class="mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
               style="width:100%;">
            <input :disabled="!isEditable()" autocomplete="off" v-model="report.service_time"
                   class="mdl-textfield__input" type="text" id="report_service_time">
            <label class="mdl-textfield__label" for="report_service_time"
                   v-text="translate('Antall reparasjonsdager')"></label>
          </div>
          <div
              v-if="$root.isAdministrator() || (!($route.params.code && (isApiReport() || isRentalReport())) && !isEuropcarReport() && !isAldReport())"
              class="mdl-cell mdl-cell--12-col ">
            <div class="mdl-textfield">
              <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect"
                     :class="[report.is_dbs_tariff ? 'is-checked' : '']" for="is_dbs_tariff">
                <input :disabled="!isEditable()" type="checkbox" id="is_dbs_tariff" v-model="report.is_dbs_tariff"
                       class="mdl-checkbox__input">
                <span class="mdl-checkbox__label" v-text="translate('DBS takst er benyttet')"></span>
              </label>
            </div>
            <div class="mdl-textfield">
              <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect"
                     :class="[report.is_repaired_by_ws ? 'is-checked' : '']" for="is_repaired_by_ws">
                <input :disabled="!isEditable()" type="checkbox" id="is_repaired_by_ws"
                       v-model="report.is_repaired_by_ws" class="mdl-checkbox__input">
                <span class="mdl-checkbox__label" v-text="translate('Reparasjon er gjennomført')"></span>
              </label>
            </div>
          </div>
        </div>

        <div class="mdl-grid" style="text-align: center;">
          <div class="report-send-actions mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-phone">
            <button v-if="$root.isClient() && client && !report.id_parent_report" @click="createClientReport()"
                    :disabled="$root.ui.isLoading('dataSaving')" class="mdl-button mdl-js-button mdl-button--raised">
              {{ translate('Rediger rapport') }}
            </button>
            <a v-if="!isEuropcarReport() && !isAldReport()" target="_blank"
               :href="'/wp-admin/admin-ajax.php?action=at_report_pdf&id=' + report.id"
               :disabled="$root.ui.loading == 'dataSaving'" class="mdl-button mdl-button--raised">
              PRINT
            </a>
            <button
                v-if="($root.isSurveyorCapability() || $root.isRentalCapability() || $root.isRentalCheckCapability() || $root.isEuropcarCapability() || $root.isAldCapability()) && client && !isReportClient('nettbil') && !isApiReport()"
                :disabled="$root.ui.isLoading('dataSaving')" @click="sendPdfReportToClient()"
                v-text="(isEuropcarReport() || isAldReport()) ? translate('Be om skade-takst') : translate('Send rapport til ') + client.name"
                class="mdl-button mdl-js-button mdl-button--raised">
            </button>
            <button
                v-if="( $root.isClient() || $root.isAdministrator() || ($root.isSurveyor() && report.contact_email && report.contact_email.toLowerCase() == 'testsenter@nettbil.no') ) && !isApiReport()"
                :disabled="$root.ui.isLoading('dataSaving')" @click="openPopupEmails()"
                v-text="translate('Send rapport til ') + report.contact_name"
                class="mdl-button mdl-js-button mdl-button--raised">
            </button>
            <button v-else-if="isApiReport()" :disabled="$root.ui.isLoading('dataSaving')"
                    @click="openPopupEmailsManual()" v-text="translate('Send manuell ')"
                    class="mdl-button mdl-js-button mdl-button--raised">
            </button>
            <button v-if="( $root.isClient() || $root.isAdministrator() || $root.isSixtAdmin() ) && isApiReport()"
                    :disabled="$root.ui.isLoading('dataSaving')" @click="openPopupActions()"
                    v-text="translate('Send eller avslå takst')" class="mdl-button mdl-js-button mdl-button--raised">
            </button>
            <button v-if="$root.isEuropcarCapability() && isEuropcarReport()"
                    :disabled="$root.ui.isLoading('dataSaving')" @click="sendPdfReportToDepartment()"
                    class="mdl-button mdl-js-button mdl-button--raised">
              {{ translate('Send til stasjon') }}
            </button>
            <button v-if="$root.isAldCapability() && isAldReport()" :disabled="$root.ui.isLoading('dataSaving')"
                    @click="copyAldReport()" class="mdl-button mdl-js-button mdl-button--raised">
              <span v-if="report.report_status == 4">{{ translate('Ny utsjekk') }}</span>
              <span v-if="report.report_status == 5">{{ translate('Ny innsjekk') }}</span>
            </button>
          </div>
          <div style="display: table-cell; margin: auto;"
               class="mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-phone">
            <router-link v-if="report.changed_at" :to="{name: 'reports-logs', params: {license: report.id_car}}"
                         v-text="'Sist endret ' + formatDate(report.sent_at, true, report.report_language)"></router-link>
            <span v-if="statusDisplay"
                  v-text="statusDisplay + formatDate(report.sent_at, true, report.report_language)"></span>
            <span v-else-if="report.report_status == 3"
                  v-text="' Rapport avslått - ' + formatDate(report.sent_at, true, report.report_language)"></span>
            <span v-else-if="report.report_status == 2"
                  v-text="' Rapport sendt til API - midlertidig - ' + formatDate(report.sent_at, true, report.report_language)"></span>
            <span v-else-if="report.report_status == 1"
                  v-text="' Rapport sendt til API - ' + formatDate(report.sent_at, true, report.report_language)"></span>
            <span v-else-if="report.sent_at"
                  v-text="'Rapport sendt ' + formatDate(report.sent_at, true, report.report_language)"></span>
            <span v-else>Rapport er ikke sendt</span>
          </div>
          <a target="_blank" :href="'/wp-admin/admin-ajax.php?action=at_report_pdf&noprice=1&id=' + report.id">Print
            uten priser</a>
        </div>

      </template>

      <div v-if="isAldReport() && !$route.params.code">
        <table class="mdl-data-table mdl-shadow--2dp">
          <thead>
          <tr>
            <th class="mdl-data-table__cell--non-numeric">Rapport dato</th>
            <th class="mdl-data-table__cell--non-numeric">ID</th>
            <th class="mdl-data-table__cell--non-numeric">Reg.Nr</th>
            <th class="mdl-data-table__cell--non-numeric">Kontaktperson</th>
            <th class="mdl-data-table__cell--non-numeric">Firma</th>
            <th class="mdl-data-table__cell--non-numeric">Bil</th>
            <th class="mdl-data-table__cell--non-numeric">Skadekostnad</th>
            <th class="mdl-data-table__cell--non-numeric">Sendt</th>
            <th class="mdl-data-table__cell--non-numeric">Taksert av</th>
          </tr>
          </thead>
          <tbody>
          <tr :id="'report-' + report.id" v-for="report in reports"
              :class="[getSentColor(report.report_status, report.sent_at) + '-chip', isMadeByCurrentUser(report) ? '' : 'marked' ]"
              @click="openReport(report)">
            <td class="mdl-data-table__cell--non-numeric"><span v-text="formatDate(report.created_at)"></span> <span
                v-if="$root.isEuropcarCapability() || $root.isAldCapability() || $root.isRentalCheckCapability()"
                v-html="getReportStatusLabel(report)"></span></td>
            <td class="mdl-data-table__cell--non-numeric" v-text="report.id"></td>
            <td class="mdl-data-table__cell--non-numeric" v-text="report.id_car.toUpperCase()"></td>
            <td class="mdl-data-table__cell--non-numeric" v-text="report.contact_name"></td>

            <td class="mdl-data-table__cell--non-numeric" v-text="report.firma"></td>
            <td class="mdl-data-table__cell--non-numeric"
                v-text="(report.producer ? report.producer : '') + ' ' + (report.model ? report.model : '')">
            </td>
            <td v-if="report.estimate > 0" class="mdl-data-table__cell--non-numeric" v-text="report.estimate"></td>
            <td v-else class="mdl-data-table__cell--non-numeric newpricing" v-text="report.lineitemsestimate"></td>


            <td v-if="report.report_status == 3" class="mdl-data-table__cell--non-numeric smaller rejected"
                v-text="report.sent_at"></td>
            <td v-else-if="report.report_status == 2" class="mdl-data-table__cell--non-numeric smaller preliminary"
                v-text="report.sent_at"></td>
            <td v-else-if="report.report_status == 1" class="mdl-data-table__cell--non-numeric smaller confirmed"
                v-text="report.sent_at"></td>
            <td v-else-if="report.sent_at" class="mdl-data-table__cell--non-numeric smaller"
                v-text="report.sent_at"></td>
            <td v-else class="mdl-data-table__cell--non-numeric smaller" v-text=""></td>

            <td class="mdl-data-table__cell--non-numeric" v-text="getReportOwnerName(report)"></td>

          </tr>
          <tr v-if="!reports.length && !$root.ui.isLoading()">
            <td colspan="7" class="mdl-data-table__cell--non-numeric">No reports</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="report-damages mdl-grid">
        <template v-for="sec in damageSections" v-if="sec.items.length">
          <div class="mdl-cell--12-col">
            <h2 v-if="($route.params.code && (isApiReport() || isRentalReport() || isEuropcarReport() || isAldReport())) && sec.caption == 'Takstpunkter'"
                class="mdl-typography--title" v-text="translate('Skadedetaljer')"></h2>
            <h2 v-else class="mdl-typography--title" v-text="translate(sec.caption)"></h2>
          </div>
          <template v-for="item in sec.items">
            <div :class="isLimitedReport() ? '' : getStateColor(item.state)"
                 class="report-card-damage mdl-card mdl-shadow--2dp mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-phone">
              <div class="report-card-images" v-if="item.images && item.images.length">
                <a v-for="(imgSrc,imageIndex) in item.images"
                   @click.prevent="$root.showLightbox(item.images, imageIndex)" target="_blank" :href="imgSrc"
                   class="mdl-card__title"
                   :style="'background: url(' + imgSrc + ') center / cover; height: 200px;'"></a>
              </div>
              <div class="mdl-card__supporting-text" style="box-sizing: border-box; width: 100%;">
                <div v-if="!isLimitedReport() && item.caption"><b v-text="translate(item.caption)"></b></div>
                <div v-if="item.description" v-text="item.description"></div>
                <div v-if="item.condition_value"
                     v-text="item.condition_value + (item.condition_measurement ? ' ' + item.condition_measurement : '')"></div>
                <div v-if="item.extra_value" v-text="item.extra_caption + ' - ' + item.extra_value"></div>
                <div v-for="lineitem in item.lineitems" v-if="lineitem.cost > 0"
                     class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label reportcard-lineitems"
                     style="width:100%;  display: block;">
                  <span class="report_lineitem description"
                        v-text="report.report_language == 'en' && lineitem.description_en ? lineitem.description_en : lineitem.description"></span>
                  <span v-if="!isWithoutPrice()" class="report_lineitem cost" v-text="lineitem.cost + ' kr'"></span>
                </div>

                <div class="reportcard totalprice" v-if="!isWithoutPrice() && calculateItemCost(item)">
                  <span class="reportcard-summary" v-text="translate('Total kostnad')"></span>
                  <span class="reportcard-summary cost" v-text="calculateItemCost(item) + ' kr'"></span>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>

    </div>

    <div class="at-modal" v-if="popup.visible" @click.self="popup.visible=false">
      <div class="at-modal-content mdl-shadow--2dp mdl-grid">
        <p>Bekreft sending av rapport til:</p>
        <div class="mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
             style="width:100%;">
          <input autocomplete="on" v-model="popup.emails" class="mdl-textfield__input" type="text" id="popup_emails">
          <label class="mdl-textfield__label" for="popup_emails">For flere mottakere, separer epostadresse med
            komma</label>
          <ul class="mdl-list" v-if="popup_emails">
            <li v-for="email in popup_emails" v-text="email"></li>
          </ul>
        </div>
        <div class="actions">
          <button @click="popup.visible=false" class="mdl-button mdl-js-button mdl-button--raised">
            Avbryt
          </button>
          <button :disabled="!popup_emails || $root.ui.isLoading('dataSaving')" @click="sendPdfReportToContact"
                  class="mdl-button mdl-js-button mdl-button--raised">
            Ja
          </button>
        </div>
      </div>
    </div>

    <div class="at-modal" v-if="actions.visible" @click.self="actions.visible=false">
      <div class="at-modal-content mdl-shadow--2dp mdl-grid">
        <p>Velg type sending:</p>
        <div class="mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
             style="width:100%;">
          <input v-model="actions.reasons" class="mdl-textfield__input" type="text" id="actions_reasons">
          <label class="mdl-textfield__label">Begrunnelse for evt avslag eller midlertidig rapport</label>
        </div>
        <div class="actions">
          <button :disabled="$root.ui.isLoading('dataSaving')" @click="sendReportViaAPI('rejected')"
                  class="mdl-button mdl-js-button mdl-button--raised">
            Avslå
          </button>
          <button :disabled="$root.ui.isLoading('dataSaving')" @click="sendReportViaAPI('preliminary')"
                  class="mdl-button mdl-js-button mdl-button--raised">
            Midlertidig
          </button>
          <button :disabled="$root.ui.isLoading('dataSaving')" @click="sendReportViaAPI('confirmed')"
                  class="mdl-button mdl-js-button mdl-button--raised">
            Ferdig
          </button>
        </div>

        <div class="actions">
          <button @click="actions.visible=false" class="mdl-button mdl-js-button mdl-button--raised cancel spaced">
            Avbryt
          </button>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import report from '../mixins/report.js'
import reports from '../mixins/reports.js'
import clients from '../mixins/clients.js'
import reportValues from '../mixins/reportValues.js'
import utils from '../mixins/utils.js'
import mdlFix from '../mixins/mdlFix.js'

export default {
  data() {
    return {
      is_validated: false,
      popup: {
        visible: false,
        emails: ""
      },
      actions: {
        visible: false
      },
      statusDisplay: ""
    }
  },
  computed: {
    errors: function () {
      if (this.is_validated) {
        var e = {};
        if (!this.report.surveyor_initials && !this.isEuropcarReport() && !this.isAldReport())
          e.surveyor_initials = 'Navn må fylles ut';
        return e;
      } else {
        return {};
      }
    },
    popup_emails: function () {
      let emails = this.popup.emails.match(/([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+/ig);
      if (emails)
        return emails.filter(function (item, pos) {
          return emails.indexOf(item) == pos;
        })
      else
        return null
    }

  },
  methods: {
    isLimitedReport() {
      return this.$route.params.code && (this.isApiReport() || this.isRentalReport() || this.isEuropcarReport() || this.isAldReport())
    },
    isValid() {
      this.is_validated = true;
      return !(Object.keys(this.errors).length);
    },
    saveReportForm(validate) {
      if (validate && this.isValid())
        return;
      return this.sendReport();
    },
    calculateTotalCost(sections) {
      var cost = 0;
      sections.forEach(function (section) {
        section.items.forEach(function (thisitem) {
          thisitem.lineitems.forEach(function (lineitem) {

            if (lineitem.cost > 0) {
              cost = cost + parseInt(lineitem.cost);
            }

          });

        });
      });
      cost += this.report.report_fixed_cost;
      return cost
    },
    calculateItemCost(item) {


      var cost = 0;

      item.lineitems.forEach(function (lineitem) {

        if (lineitem.cost > 0) {
          cost = cost + parseInt(lineitem.cost);
        }

      });


      return cost
    },
    sendPdfReportToClient() {
      this.sendPdfReport('client');
    },
    sendPdfReportToDepartment() {
      this.sendPdfReport('department');
    },
    openPopupEmails() {
      if (!this.popup.emails) {
        this.popup.emails = this.report.contact_email
      }
      this.popup.visible = true;
    },
    openPopupEmailsManual() {
      if (!this.popup.emails) {
        this.popup.emails = ""
      }
      this.popup.visible = true;
    },
    openPopupActions() {

      this.actions.visible = true;
    },
    sendPdfReportToContact() {
      let self = this;
      self.$root.ui.loading.push('dataSaving')
      return self.$store.dispatch('sendPdfReport', {
        id: self.report.id,
        type: 'contact',
        recipients: this.popup_emails
      }).then(sent_at => {
        self.$root.ui.stopLoading('dataSaving')
        self.popup.visible = false;
      })
      //this.sendPdfReport('contact');
    },
    sendReportViaAPI(status) {

      console.log("choosen: ");
      console.log(status);

      if (!this.actions.reasons) {
        var statusDesc = "";
      } else {
        var statusDesc = this.actions.reasons;
      }

      let self = this;
      self.$root.ui.loading.push('dataSaving')
      return self.$store.dispatch('sendApiReport', {
        id: self.report.id,
        type: 'api',
        status: status,
        status_description: statusDesc
      }).then(sent_at => {
        self.$root.ui.stopLoading('dataSaving')
        self.actions.visible = false;


        console.log("report status");
        console.log(status);

        if (status == "confirmed") {
          self.statusDisplay = " Rapport sendt til API - ";
        } else if (status == "preliminary") {
          self.statusDisplay = " Rapport sendt til API - midlertidig - ";
        } else if (status == "rejected") {
          self.statusDisplay = " Rapport avslått - ";
        }


        /*
        if(this.report.report_status == 3){
      self.statusDisplay = "Rapport avslått ";
    }
    else if(this.report.report_status == 2){
      self.statusDisplay =  "Rapport sendt til API - midlertidig ";
    }
    else if(this.report.report_status == 1){
      self.statusDisplay = "Rapport sendt til API ";
    }
    */
      })
      //this.sendPdfReport('contact');
    },
    sendPdfReport(recipientType, language, showPrices) {
      var self = this
      var message = '<div style="font-size:22px">Bekreft sending av rapport</div><div style="font-size:13px">En kopi vil opprettes hos mottaker</div>';
      if (self.isEuropcarReport() || self.isAldReport()) {
        message = '<div style="font-size:22px">Bekreft sending</div>';
      }
      if (self.isValid()) {
        self.$dialog.confirm(message, {
          cancelText: 'Avbryt',
          okText: 'Ja',
          backdropClose: true,
          html: true
        }).then(function () {
          self.$root.ui.loading.push('dataSaving')
          return self.$store.dispatch('sendPdfReport', {
            id: self.report.id,
            type: recipientType,
            recipients: self.popup_emails
          }).then(sent_at => {
            self.$root.ui.stopLoading('dataSaving')
          })
        })
      } else if (!self.report.surveyor_initials) {
        self.$dialog.confirm('Vennligst skriv inn navn eller initialer på taksmann før rapporten sendes.', {
          cancelText: 'Avbryt',
          okText: 'Lagre',
          backdropClose: true
        })
      }
    },
    createClientReport() {
      var self = this
      self.$dialog.confirm('<div style="font-size:22px">Bekreft sending av rapport</div><div style="font-size:13px">En kopi vil opprettes hos mottaker</div>', {
        cancelText: 'Avbryt',
        okText: 'Ja',
        backdropClose: true,
        html: true
      }).then(function () {
        self.$root.ui.loading.push('dataSaving')
        return self.$store.dispatch('createClientReport', self.report.id).then(data => {
          self.$root.ui.stopLoading('dataSaving')
          self.$router.push({name: 'report', params: {id: data.id}});
        })
      })
    },
    copyAldReport() {
      var self = this
      self.$dialog.confirm('Are you sure?', {
        cancelText: 'Avbryt',
        okText: 'Ja',
        backdropClose: true,
        html: true
      }).then(function () {
        self.$root.ui.loading.push('dataSaving')
        return self.$store.dispatch('copyAldReport', self.report.id).then(data => {
          self.$root.ui.stopLoading('dataSaving')
          self.$router.push({name: 'report-contact', params: {id: data.id}});
        })
      })
    }
  },
  mixins: [clients, report, reportValues, reports, utils, mdlFix]
}

</script>

<style lang="scss">
.at-modal p {
  font-size: 150%;
}

.at-modal {
  z-index: 1;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
}

.at-modal-content.mdl-grid {
  width: 100%;
  max-width: 400px;
  background-color: white;
  padding: 20px;
}

.at-modal .actions {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.at-modal .actions .mdl-button {
  margin-left: 20px;
}

.at-modal .mdl-list {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// ReportForm.vue?636c0126